// Главная по умолчанию показывает WB и Ozon вместе (решение Operus 22.10, как в прототипе).
// Выбор живёт до перезагрузки страницы и меняется только кнопками «Все · WB · Ozon» на Главной,
// поэтому выбор маркетплейса на других страницах его не сбивает.

export const setHomeAllAction = (value) => ({ type: "SET_HOME_ALL", value: Boolean(value) });

const homeScopeReducer = (state = { all: true }, action) => {
  if (action.type === "SET_HOME_ALL" && state.all !== action.value) return { ...state, all: action.value };
  return state;
};

export default homeScopeReducer;
